import BlazeSlider from '../news/blaze'
import inx from 'inx'

/** Get weather info from api.met.no (yr.no)
 * Weather api documentation: http://api.met.no/weatherapi/locationforecastlts/1.2/documentation
 */
function render(weatherEl, data) {
    // data = testingData;
    const
        {
            geoip,
            weather
        } = data,
        hasAllValues = Object.keys(weather).every(key => weather[key] !== null);

    if (!weatherEl) {
        return;
    }
    // Handle case when json is received, but current weather conditions contains "null" values
    if (!hasAllValues) {
        return;
    }

    //get temperature parameter from weather object

    //normalize weather
    const lang = document.querySelector('html').getAttribute('lang')
        .replace('ee', 'et')
        .replace('en', 'en-150') //European English. to avoid showing AM/PM as for en-US/en-GB locale
    ;

    //todo pass locale
    //todo add AM/PM for specific locales
    const currTime = new Date().toLocaleTimeString(lang, { hour: "2-digit", minute: "2-digit" });

    let parsedWeather = [
        {
            temp: weather.currTemp,
            feelsLikeTemp: weather.feelsLikeTemp ?? weather.currTemp, //with old weather fallback
            icoSymbol: weather.icoSymbol,
            humidity: weather.humidity,
            windSpeed: weather.windSpeed,
            windGust: weather.windGust,
            period: currTime,
        }
    ];

    if (typeof weather.forecastHourPeriods !== 'undefined') {
        const geoTimezone = geoip.timezone;
        weather.forecastHourPeriods.forEach((item) => {
            item.temp = ((parseFloat(item.tempHigh) + parseFloat(item.tempLow)) / 2).toFixed(1);
            //todo pass locale
            //todo add AM/PM for specific locales
            const hourFrom = new Date(item.periodStart).toLocaleTimeString(lang, { timeZone: geoTimezone, hour: "2-digit" });
            const hourTo = new Date(item.periodEnd).toLocaleTimeString(lang, { timeZone: geoTimezone, hour: "2-digit" });
            item.period = `${hourFrom}-${hourTo}`;

            parsedWeather.push(item);
        });

        weather.forecastDayPeriods.forEach((item) => {
            item.temp = ((parseFloat(item.tempHigh) + parseFloat(item.tempLow)) / 2).toFixed(1);
            //todo pass locale
            //todo add AM/PM for specific locales
            item.period = new Date(item.periodStart).toLocaleDateString(lang, { timeZone: geoTimezone, weekday: 'short' });
            // parsedWeather.push(item);
        });
    }

    //if no namedays we show 2 lines of weather info
    const hasNamedays = !!document.querySelector('.panel-nameday');
    const isMobileWidget = !!weatherEl.closest('.mobile-widgets');

    //for mobile always show 6 items
    const itemCount = hasNamedays && !isMobileWidget ? 3 : 6;

    console.log({
        itemCount,
        isMobileWidget,
        hasNamedays,
    });

    const hourPeriods = parsedWeather.slice(0, itemCount + 1);

    let allDayPeriods = weather.forecastDayPeriods;
    if (allDayPeriods === undefined) { //for old weather api compatibility
        allDayPeriods = [];
    }
    const dayPeriods = allDayPeriods.slice(0, itemCount);

    const { i18n } = inx;

    const weatherBlocks = [
        {
            values: hourPeriods.map((item) => `${Math.round(item.temp)}℃`),
            title: i18n.weatherNow
        },
        {
            values: hourPeriods.map((item) => `${Math.round(item.feelsLikeTemp)}℃`),
            title: i18n.feelsLike
        },
        {
            values: hourPeriods.map((item, i) => `${Math.round(item.windSpeed)} ${item.windGust ? `(${Math.round(item.windGust)})` : ''} ${i === 0 ? i18n.metersPerSecond : ''}`),
            title: i18n.wind
        },
        {
            values: hourPeriods.map((item) => `${Math.round(item.humidity)}%`),
            title: i18n.humidity
        }
    ];

    function renderWeatherBlock(weatherItems, weatherValues, title) {
        return `
            <div class="d-flex flex-column h-100" style="margin-left: -6px">
                <div class="weather-item-main-block d-flex flex-row align-items-center justify-content-start pt-3 ps-2">
                    <span class="ico-meteo" style="background-image: url('/assets/portal/img/meteo-icons2/${weatherItems[0].icoSymbol.toLowerCase()}.svg');"></span>
                    <span class="weather-value ms-1 fs-5 fw-medium">${weatherValues[0]}</span>
                    <span class="weather-type ms-3 secondary-text">${title}</span>
                </div>
                <div class="weather-item-container h-100 mt-2">
                       ${weatherItems.map((item, itemIndex) => itemIndex > 0 ? `
                            <div>
                                <span class="secondary-text text-nowrap">${item.period}</span>
                                <div class="d-flex flex-row align-items-center justify-content-center">
                                    <span class="ico-meteo" style="background-image: url('/assets/portal/img/meteo-icons2/${item.icoSymbol.toLowerCase()}.svg');"></span>
                                    <span class="secondary-text text-black fw-medium">${weatherValues[itemIndex]}</span>
                                </div>
                            </div>
                       ` : ``).join('')}
                </div>
            </div>
        `;
    }

    const weatherMarkup = `
            <div class="d-flex flex-column h-100 ${itemCount === 6 ? 'weather-full' : ''}">
                <div class="d-flex flex-row justify-content-between">
                    <div>
                        <a href="https://www.yr.no/en/forecast/daily-table/${geoip.latitude},${geoip.longitude}" class="fw-medium">
                            ${geoip.city.replace('Riga', 'Rīga')}
                        </a>
                    </div>
                    <div>
                        <a class="blaze-next icon-link-hover">
                            <svg class="bi" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15.8538 10.3538L11.3538 14.8538C11.2599 14.9476 11.1327 15.0003 11 15.0003C10.8673 15.0003 10.7401 14.9476 10.6462 14.8538C10.5524 14.76 10.4997 14.6327 10.4997 14.5C10.4997 14.3674 10.5524 14.2401 10.6462 14.1463L14.2931 10.5H4.5C4.36739 10.5 4.24021 10.4474 4.14645 10.3536C4.05268 10.2598 4 10.1326 4 10C4 9.86743 4.05268 9.74025 4.14645 9.64648C4.24021 9.55271 4.36739 9.50003 4.5 9.50003H14.2931L10.6462 5.85378C10.5524 5.75996 10.4997 5.63272 10.4997 5.50003C10.4997 5.36735 10.5524 5.2401 10.6462 5.14628C10.7401 5.05246 10.8673 4.99976 11 4.99976C11.1327 4.99976 11.2599 5.05246 11.3538 5.14628L15.8538 9.64628C15.9002 9.69272 15.9371 9.74786 15.9623 9.80856C15.9874 9.86926 16.0004 9.93433 16.0004 10C16.0004 10.0657 15.9874 10.1308 15.9623 10.1915C15.9371 10.2522 15.9002 10.3073 15.8538 10.3538Z" fill="#808084"/>
                            </svg>
                        </a>
                    </div>
                </div>
                <div class="d-flex flex-row  h-100">
                    <div class="blaze-slider w-100  h-100">
                        <div class="blaze-container  h-100">
                            <div class="blaze-track-container  h-100">
                                <div class="blaze-track h-100">
                                    ${weatherBlocks.map((item) => renderWeatherBlock(hourPeriods, item.values, item.title)).join('')}
                                    
                                    <div class="weather-item-container mt-2">
                                        ${dayPeriods.map((item) => `       
                                            <div class="d-flex flex-column align-items-center justify-content-center">
                                                <span class="secondary-text text-nowrap">${item.period}</span>
                                                <span class="ico-meteo" style="background-image: url('/assets/portal/img/meteo-icons2/${item.icoSymbol.toLowerCase()}.svg');"></span>
                                                <span class="secondary-text text-black fw-medium">${Math.round(item.tempHigh)}° <span class="text-secondary">${Math.round(item.tempLow)}°</span></span>
                                            </div>
                                       `).join('')}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;

    weatherEl.innerHTML = weatherMarkup;
    const sliderEl = weatherEl.querySelector('.blaze-slider');

    const slider = new BlazeSlider(sliderEl, {
        all: {
            enableAutoplay: true,
            autoplayInterval: 4000,
            transitionDuration: 200,
            slidesToShow: 1,

        },
    });
    sliderEl.parentNode.parentNode.querySelectorAll('.blaze-next').forEach(el => el.addEventListener('click', () => slider.next()));
}

export default async function (params) {
    if (!params) {
        return;
    }
    if (params.apiUrl === undefined) {
        return;
    }
    if (params.enabled && params.enabled === false) {
        return;
    }
    // Get weather json
    const portalWeatherSelector = '.panel-weather2';
    try {
        //params.apiUrl Defined in head_assets template
        const data = await fetch(params.apiUrl, {
            method: 'GET'
        });
        const jsonResponse = await data.json();
        document.querySelectorAll(portalWeatherSelector).forEach(el => render(el, jsonResponse));
    } catch (err) {
        document.querySelectorAll(portalWeatherSelector).forEach(el => el.style.display = 'none');
        console.log(err);
    }
}
